import type { FC } from 'react'

import { Button } from 'common/components/Button/Button'
import {
  BUTTON_CONSTANTS,
  BUTTON_MODIFIER,
  BUTTON_SEVERITY,
} from 'common/constants/buttonConstants'

import styles from './ehrAppointmentV2.module.scss'

type Props = {
  title: string
  subtitle: string
  error?: string
  isSaving: boolean
  canSave: boolean
  canDelete: boolean
  hasSearched: boolean
  onClearSearch: () => void
  onSave: () => void
  onDelete: () => void
  onCancel: () => void
}

export const FooterBar: FC<Props> = ({
  title,
  subtitle,
  error,
  isSaving,
  canSave,
  canDelete,
  hasSearched,
  onClearSearch,
  onSave,
  onDelete,
  onCancel,
}) => (
  <div className={styles.footer}>
    <div className={styles.footerSummary}>
      <span className={styles.footerKicker}>Appointment</span>
      <span className={styles.footerTitle}>{title}</span>
      <span className={error ? styles.errorText : styles.footerSub}>{error ?? subtitle}</span>
    </div>

    <div className={styles.fieldGrow} />

    <div className={styles.footerActions}>
      {hasSearched && <Button onClick={onClearSearch}>Clear search</Button>}

      <Button
        onClick={onSave}
        loading={isSaving}
        disabled={!canSave}
        data-cy='submit-btn'
        severity={BUTTON_SEVERITY.SUCCESS_FILLED}>
        {BUTTON_CONSTANTS.SAVE}
      </Button>

      {canDelete && (
        <Button
          onClick={onDelete}
          disabled={isSaving}
          severity={BUTTON_SEVERITY.DANGER}
          modifier={BUTTON_MODIFIER.PRIMARY}>
          {BUTTON_CONSTANTS.DELETE}
        </Button>
      )}

      <Button onClick={onCancel} data-cy='cancel-btn' disabled={isSaving}>
        {BUTTON_CONSTANTS.CANCEL}
      </Button>
    </div>
  </div>
)
